import { baseApi } from "common/redux/core/api.base";
import { DocumentService } from "../../services/documents.service";
import { ListParam } from "../../models/document.model";
import { ApiCacheTags } from "common/models";

const adminDocumentsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAdminDocuments: build.query<any, any>({
      queryFn: (listParam: any) => DocumentService.getAdminDocuments(listParam),
      providesTags: [ApiCacheTags.DOCUMENT_LISTS]
    })
  })
});

export const { useGetAdminDocumentsQuery, useLazyGetAdminDocumentsQuery } =
  adminDocumentsApi;
